export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";